import {Toast} from "primereact/toast";
import React from "react";

export default function callToast(toast: React.RefObject<Toast | null>, type: boolean | string, msg: string, life: number = 3000) {
    if (toast?.current) {
        toast?.current?.show({
            severity: type === "warn" ? "warn" : type ? "success" : "error",
            summary: type === "warn" ? "Warning" : type ? "Successful" : "Error",
            detail: msg,
            life: life,
        });
    }
}
export const postJson = (data: any) => {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }
}
// Post File Format
export const postFile = (File: any) => {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: File,
    }
}
// Catch Error
export const catchError = (error: any) => {
    console.log(error)
}
export const getDivisionWiseUrl = (id:any)=>{
    const urls = [
        {
            id:8,
            url:'human'
        },
        {
            id:9,
            url:'animal'
        },
        {
            id:10,
            url:'herbal'
        },
        {
            id:11,
            url:'crop'
        },
        {
            id:12,
            url:'agro'
        },
        {
            id:13,
            url:'paw-mania'
        },
        {
            id:14,
            url:'garden'
        },
    ]
    return urls.find((url)=>Number(url.id)===Number(id))
}
export const depots = [
    { name: 'Chemist Laboratories', code: '8' },
    { name: 'Chemist Animal Health', code: '9' },
    { name: 'Chemist Herbal Care & Nutraceuticals', code: '10' },
    { name: 'Chemist Crop Care', code: '11' },
    { name: 'Chemist Agrobiotech', code: '12' },
    { name: 'Chemist Gardenia Nursery', code: '14' },
    { name: 'Chemist Pet Care', code: '13' },
    { name: 'Chemist Group', code: '15' }
];
// export const showErrors = (errors:any,toast:any) => {
//     if (!errors) return;
//     Object.values(errors).forEach((fieldErrors:any) => {
//         if (Array.isArray(fieldErrors)) {
//             fieldErrors.forEach((msg:string) => {
//                 toast.current.show({
//                     severity: "error",
//                     summary: "Validation Error",
//                     detail: msg,
//                     life: 4000,
//                 });
//             });
//         } else {
//             toast.current.show({
//                 severity: "error",
//                 summary: "Error",
//                 detail: fieldErrors,
//                 life: 4000,
//             });
//         }
//     });
// };

export const showErrors = (errors: any, toast: any) => {
    if (!errors || !toast?.current) return;

    Object.values(errors).forEach((fieldErrors: any) => {
        if (Array.isArray(fieldErrors)) {
            fieldErrors.forEach((msg: string) => {
                toast.current?.show({
                    severity: "error",
                    summary: "Validation Error",
                    detail: msg,
                    life: 4000,
                });
            });
        } else {
            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: fieldErrors,
                life: 4000,
            });
        }
    });
};